import { SeniorityLevelEnum } from '../constants/enums/ProficiencyLevelsEnum';

export interface ISeniorityRequirement {
  seniorityId: string;
  requiredLevel: number;
}

// Rank order used to inherit the required level from the closest lower seniority tier.
const SENIORITY_RANK: Record<string, number> = {
  [SeniorityLevelEnum.JUNIOR]: 0,
  [SeniorityLevelEnum.MID]: 1,
  [SeniorityLevelEnum.SENIOR]: 2,
};

// Resolves the required level for a seniority: exact match wins, otherwise inherits the
// highest requiredLevel among entries ranked at or below the selected level, else 0.
export const getRequiredLevelForSeniority = (
  seniorityRequirements: ISeniorityRequirement[] | null | undefined,
  selectedSeniority: string | null | undefined,
): number => {
  const requirements = seniorityRequirements ?? [];
  const exactMatch = requirements.find((req) => req.seniorityId === selectedSeniority);

  if (exactMatch) {
    return Number(exactMatch.requiredLevel);
  }

  const selectedRank = selectedSeniority ? SENIORITY_RANK[selectedSeniority] : undefined;

  if (selectedRank === undefined) {
    return 0;
  }

  const inheritedLevel = requirements.reduce((maxLevel, req) => {
    const rank = SENIORITY_RANK[req.seniorityId];

    if (rank === undefined || rank > selectedRank) {
      return maxLevel;
    }

    return Math.max(maxLevel, Number(req.requiredLevel));
  }, -Infinity);

  return inheritedLevel === -Infinity ? 0 : inheritedLevel;
};
